import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="d-sm-flex justify-content-center justify-content-sm-between">
          <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
            Copyright © {new Date().getFullYear()}{" "}
            <a href="https://kusumindustries.com/" target="_blank">
              Kusum Indsutries
            </a>
            . All rights reserved.
          </span>
          <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
            Developed By{" "}
            <a href="https://bitbyteindia.com/" target="_blank">
              Bitbyteindia.com{" "}
            </a>{" "}
          </span>
          {/* <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted &amp; made with <i className="mdi mdi-heart text-danger" /></span> */}
        </div>
      </footer>
    </>
  );
};

export default Footer;
